import api from './api';

export type EntityType = 'Invoice' | 'User' | 'SellerConfig' | 'Order';
export type AuditAction = 'CREATE' | 'UPDATE' | 'DELETE' | 'STATUS_CHANGE';

export interface AuditLog {
  id: string;
  entityType: EntityType;
  entityId: string;
  action: AuditAction;
  changedBy: string | null;
  changedByUsername: string | null;
  oldData: any;
  newData: any;
  changedFields: string[];
  description: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
}

export interface AuditLogFilters {
  entityType?: EntityType;
  entityId?: string;
  action?: AuditAction;
  changedBy?: string;
  startDate?: string;
  endDate?: string;
}

export interface AuditLogResponse {
  logs: AuditLog[];
  total: number;
  limit: number;
  offset: number;
}

export interface EntityAuditLogResponse {
  logs: AuditLog[];
  entityType: string;
  entityId: string;
}

/**
 * Lädt alle Audit-Logs mit optionalen Filtern
 */
export const getAllAuditLogs = async (
  filters?: AuditLogFilters,
  limit: number = 100,
  offset: number = 0
): Promise<AuditLogResponse> => {
  const params: any = { limit: limit.toString(), offset: offset.toString() };
  
  if (filters?.entityType) params.entityType = filters.entityType;
  if (filters?.entityId) params.entityId = filters.entityId;
  if (filters?.action) params.action = filters.action;
  if (filters?.changedBy) params.changedBy = filters.changedBy;
  if (filters?.startDate) params.startDate = filters.startDate;
  if (filters?.endDate) params.endDate = filters.endDate;

  const response = await api.get<AuditLogResponse>('/admin/audit-logs', { params });
  return response.data;
};

/**
 * Lädt Audit-Logs für eine spezifische Entität
 */
export const getEntityAuditLogs = async (
  entityType: EntityType,
  entityId: string,
  limit: number = 100
): Promise<EntityAuditLogResponse> => {
  const response = await api.get<EntityAuditLogResponse>(
    `/admin/audit-logs/${entityType}/${entityId}`,
    { params: { limit: limit.toString() } }
  );
  return response.data;
};

